import create from 'zustand';
import { supabase } from '../integrations/supabase/client';


const useArticleStore = create((set, get) => ({
  articles: [],
  featuredArticles: [],
  isLoading: false,
  error: null,
  
  // Get articles by category
  getArticlesByCategory: (category, limit = 10) => {
    const articles = get().articles;
    console.log(`Getting articles for category ${category}, total ${articles.length} articles`);

    // If there's actual data, filter by category
    if (articles.length > 0) {
      // Return all if category is 'all'
      if (category === 'all') {
        return articles.slice(0, limit);
      }
      
      // 否则过滤特定分类
      const filtered = articles.filter(article => article.category === category);
      console.log(`分类 ${category} 过滤后剩余 ${filtered.length} 篇`);
      return filtered.slice(0, limit);
    }
    
    // Return empty array if no data
    return [];
  },

  // Fetch articles data from Supabase
  fetchArticles: async () => {
    // 检查网络连接状态
    if (!navigator.onLine) {
      console.log('网络已断开，无法获取文章数据');
      set({ 
        error: '网络连接已断开',
        isLoading: false 
      });
      return;
    }
    
    console.log('Starting to fetch articles data');
    set({ isLoading: true });
    try {
      // Get articles data
      const { data: articles, error } = await supabase
        .from('article')
        .select('*')
        .order('published_at', { ascending: false });

      if (error) {
        console.error('Failed to fetch articles:', error);
        throw error;
      }

      console.log(`Retrieved ${articles?.length || 0} articles from database`);

      // Get feed data to associate categories
      const { data: feeds } = await supabase
        .from('feed')
        .select('feed_id, category');

      console.log(`Retrieved ${feeds?.length || 0} feeds from database`);
      
      // Create mapping from feed_id to category
      const feedCategories = {};
      feeds?.forEach(feed => {
        feedCategories[feed.feed_id] = feed.category;
      });

      // Use only data retrieved from database, use empty array if no data
      const finalArticles = articles || [];

      console.log('文章数据准备完成，更新状态');
      set({
        articles: finalArticles,
        featuredArticles: finalArticles.slice(0, 5),
        isLoading: false
      });
    } catch (error) {
      console.error('Error fetching articles:', error);
      
      set({
        articles: [],
        featuredArticles: [],
        error: error.message,
        isLoading: false
      });
    }
  }
}));

export default useArticleStore; 